export function readConfigJson<T>(elementId: string): T {
    const element = document.getElementById(elementId);

    if (!element)
        throw new Error(`Could not find element with id #${elementId}.`)

    return JSON.parse(element.innerHTML);
}
